module.exports = __webpack_public_path__ + "media/images/bg_top_mv_pc-1f056f714513cada46b815c3514b63d2.jpg";